<template>
  <v-card class="mx-auto my-4" max-width="800" flat outlined>
    <v-card-title class="pb-3">
      {{ $t("settings.notificationSettings.title") }}
    </v-card-title>
    <v-card-subtitle class="pb-0">
      {{ $t("settings.notificationSettings.description") }}
    </v-card-subtitle>
    <v-card-text class="pt-4">
      <div
        v-for="section in notificationSections"
        :key="section.key"
        class="assignment-row"
      >
        <div class="assignment-label">{{ section.label }}</div>
        <v-autocomplete
          v-model="notifications[section.key]"
          :items="users"
          :label="$t('notifications.dialog.usersLabel')"
          :loading="loading"
          :disabled="isReadOnlyUser"
          item-text="name"
          item-value="_id"
          multiple
          chips
          small-chips
          deletable-chips
          outlined
          dense
          hide-details
        />
      </div>
    </v-card-text>
    <v-card-actions class="px-6 pb-4">
      <v-spacer />
      <v-btn
        v-if="!isReadOnlyUser"
        color="primary"
        outlined
        :loading="saving"
        @click="save"
      >
        {{ $t("general.save") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "emailNotificationSettings",
  data: () => ({
    notifications: {
      medkitLog: [],
      incidentReport: [],
      proof: [],
      statisticsMonthly: [],
      statisticsYearly: [],
    },
    users: [],
    loading: false,
    saving: false,
  }),
  computed: {
    notificationSections() {
      return [
        {
          key: "medkitLog",
          label: this.$t("settings.notificationSettings.medkitLog"),
        },
        {
          key: "incidentReport",
          label: this.$t("settings.notificationSettings.incidentReport"),
        },
        {
          key: "proof",
          label: this.$t("settings.notificationSettings.proof"),
        },
      ];
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      try {
        const [subscribers, usersData] = await Promise.all([
          this.$store.dispatch("getNotificationSubscribers"),
          this.$store.dispatch("getUsersData"),
        ]);
        this.users = usersData || [];

        const nv = (subscribers && subscribers.value) || {};
        this.notifications = {
          medkitLog: [...(nv.medkitLog || [])],
          incidentReport: [...(nv.incidentReport || [])],
          proof: [...(nv.proof || [])],
          statisticsMonthly: [...(nv.statisticsMonthly || [])],
          statisticsYearly: [...(nv.statisticsYearly || [])],
        };
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.saving = true;
      try {
        await this.$store.dispatch("setNotificationSubscribers", {
          medkitLog: this.notifications.medkitLog,
          incidentReport: this.notifications.incidentReport,
          proof: this.notifications.proof,
          statisticsMonthly: this.notifications.statisticsMonthly,
          statisticsYearly: this.notifications.statisticsYearly,
        });
        this.$store.commit(
          "CREATE_SNACKBAR",
          this.$t("general.savedSuccessfully")
        );
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.assignment-row {
  margin-bottom: 20px;
}
.assignment-row:last-child {
  margin-bottom: 0;
}
.assignment-label {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 8px;
}
</style>
